<template>
  <div class="item-container">
    <div class="item-img" v-if="every.cover">
      <div class="right" v-if="every.cover" @click="$emit('itemClick', every)">
        <img v-lazy="$global.imgUrl + every.cover" alt="" />
      </div>
      <div class="left">
        <h2 class="title" v-html="every.title" @click="$emit('itemClick', every)"></h2>
        <ul class="anther">
          <li v-if="every.authorList">
            {{every.authorList[0]}}
          </li>
        </ul>
        <div class="content" v-if="every.artSummary" v-html="every.artSummary"></div>
        <ul class="icon">
          <li @click.stop="collect()">
            <img v-if="isCollect" src="@/assets/img/qietu/sc.png" alt="" />
            <img v-else src="@/assets/img/qietu/kongxin.png" alt="" />
            <span>收藏</span>
          </li>
          <li class="share">
            <img src="@/assets/img/qietu/share.png" alt="" />
            <div>分享</div>
            <ul class="share_box">
              <div class="sanjiao"></div>
              <li @mouseover.stop="weChat" class="weChat">
                <img src="@/assets/img/details/WeChat.png" alt="" />
                <div>微信</div>
                <div
                  :id="`WXqrcode${curcer}`"
                  :ref="`WXqrcode${curcer}`"
                  class="ma"
                ></div>
              </li>
              <li @click.stop="weibo">
                <img src="@/assets/img/details/weiBo.png" alt="" />
                <div>新浪微博</div>
              </li>
              <li @mouseover.stop="qq" class="qq">
                <img src="@/assets/img/details/QQ.png" alt="" />
                <div>QQ</div>
                <div
                  :id="`QQqrcode${curcer}`"
                  :ref="`QQqrcode${curcer}`"
                  class="ma"
                ></div>
              </li>
              <li @click.stop="space">
                <img src="@/assets/img/details/qqspace.png" alt="" />
                <div>QQ空间</div>
              </li>
            </ul>
          </li>
          <li v-if="every.articleType !== 5" @click.stop="downPdf(every.articleType, every.articleId)">
            <img src="@/assets/img/qietu/down.png" alt="" />
            <span>下载</span>
          </li>
          <Button
            v-if="every.articleType !== 5"
            class="readBtn"
            @click.stop="read(every.articleType, every.articleId)"
            v-throttleClick
          >
            <img src="@/assets/img/qietu/write.png" alt="" />
            <span>在线阅读</span>
          </Button>
        </ul>
        <div class="time">
          {{ every.originalPublishTime ? every.originalPublishTime.slice(0,10) : every.createTime.slice(0,10) }}
        </div>
      </div>
    </div>
    <div class="item-no-img" v-else>
      <div class="top">
        <h2 class="title" v-html="every.title" @click="$emit('itemClick', every)"></h2>
        <div class="mettingTime">
          {{ every.mettingTime }}
        </div>
      </div>
      <ul class="anther">
        <li v-for="(item, index) in every.authorList" :key="index">
          {{ item }}
        </li>
      </ul>
      <div class="content" v-html="every.artSummary"></div>
      <ul class="icon">
        <li @click.stop="collect()">
          <img v-if="isCollect" src="@/assets/img/qietu/sc.png" alt="" />
          <img v-else src="@/assets/img/qietu/kongxin.png" alt="" />
          <span>收藏</span>
        </li>
        <li class="share">
          <img src="@/assets/img/qietu/share.png" alt="" />
          <div>分享</div>
          <ul class="share_box">
            <div class="sanjiao"></div>
            <li @mouseover.stop="weChat" class="weChat">
              <img src="@/assets/img/details/WeChat.png" alt="" />
              <div>微信</div>
              <div
                :id="`WXqrcode${curcer}`"
                :ref="`WXqrcode${curcer}`"
                class="ma"
              ></div>
            </li>
            <li @click.stop="weibo">
              <img src="@/assets/img/details/weiBo.png" alt="" />
              <div>新浪微博</div>
            </li>
            <li @mouseover.stop="qq" class="qq">
              <img src="@/assets/img/details/QQ.png" alt="" />
              <div>QQ</div>
              <div
                :id="`QQqrcode${curcer}`"
                :ref="`QQqrcode${curcer}`"
                class="ma"
              ></div>
            </li>
            <li @click.stop="space">
              <img src="@/assets/img/details/qqspace.png" alt="" />
              <div>QQ空间</div>
            </li>
          </ul>
        </li>
        <li v-if="every.articleType !== 5" @click.stop="downPdf(every.articleType, every.articleId)">
          <img src="@/assets/img/qietu/down.png" alt="" />
          <span>下载</span>
        </li>
        <Button
          v-if="every.articleType !== 5"
          class="readBtn"
          @click.stop="read(every.articleType, every.articleId)"
          v-throttleClick
        >
          <img src="@/assets/img/qietu/write.png" alt="" />
          <span>在线阅读</span>
        </Button>
      </ul>
      <div v-if="every.articleType === 5" class="time">
        {{ every.originalPublishTime ? every.originalPublishTime.slice(0,10) : every.createTime.slice(0,10) }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import QRCode from "qrcodejs2";
export default {
  props: {
    every: {
      type: Object,
      required: true,
    },
    curcer: {
      type: String,
    },
  },
  created() {
    if (this.hasLogin) {
      this.TFCollect();
    }
  },
  computed: {
    ...mapState(["hasLogin", "token"]),
  },
  data() {
    return {
      WXurl: "",
      QQurl: "",
      isCollect: false,
    };
  },
  methods: {
    async read(type, id) {
      if (!this.hasLogin) {
        this.$bus.$emit("showModel", true);
        return;
      }
      let obj = {
        articleId: id,
        articleType: type,
      };
      let res = await this.$apis.mainServe.hasFile(obj);
      if (res.resultCode !== "200") {
        this.$Message.error("没有文献");
        return false;
      }
      window.open(
        this.$apis.mainServe.readUrl +
          "?articleId=" +
          id +
          "&articleType=" +
          type +
          "&token=" +
          this.token
      );
    },
    async downPdf(type, id) {
      if (!this.hasLogin) {
        this.$bus.$emit("showModel", true);
        return;
      }
      let obj = {
        articleId: id,
        articleType: type,
      };
      let res = await this.$apis.mainServe.hasFile(obj);
      if (res.resultCode !== "200") {
        this.$Message.error("没有文献");
        return false;
      }
      window.open(
        this.$apis.mainServe.download +
          "?articleId=" +
          id +
          "&articleType=" +
          type +
          "&token=" +
          this.token
      );
    },
    // 收藏
    async collect() {
      if (!this.hasLogin) {
        this.$bus.$emit("showModel", true);
        return;
      }
      let obj = {
        action: this.isCollect ? 0 : 1,
        articleId: this.every.articleId,
        articleType: this.every.articleType,
      };
      let res = await this.$apis.recomendServe.CollectItem(obj);
      console.log(res);
      await this.TFCollect();
    },
    async TFCollect() {
      let obj = {
        articleId: this.every.articleId,
        articleType: this.every.articleType,
      };
      let res = await this.$apis.recomendServe.isCollect(obj);
      this.isCollect = res.isCollect;
    },
    getUrl() {
      let url = "";
      if (this.every.articleType === 0) {
        // 论文
        url = 
          this.$global.url1 +
          `thesisDetail?type=${this.every.articleType}&id=${this.every.articleId}`;
      } else if (this.every.articleType === 6) {
        // 报告
        url =
          this.$global.url1 +
          `dataDetails?type=${this.every.articleType}&id=${this.every.articleId}`;
      } else if (this.every.articleType === 5) {
        // 资讯
        url =
          this.$global.url1 +
          `msgDetails?type=${this.every.articleType}&id=${this.every.articleId}`;
      }
      return url;
    },
    weChat() {
      if (this.WXurl !== "") return;
      this.WXurl = this.getUrl();
      // 使用$nextTick确保数据渲染
      this.$nextTick(() => {
        this.WXcrateQrcode();
      });
    },
    WXcrateQrcode() {
      this.qr = new QRCode("WXqrcode" + this.curcer, {
        width: 150,
        height: 150, // 高度
        text: this.WXurl, // 二维码内容
      });
    },
    QQcrateQrcode() {
      this.qr = new QRCode("QQqrcode" + this.curcer, {
        width: 150,
        height: 150, // 高度
        text: this.QQurl, // 二维码内容
      });
      // console.log(this.$refs.WXqrcode)
    },
    qq() {
      console.log(1);
      if (this.QQurl !== "") return;
      console.log(2);
      this.QQurl = this.getUrl();
      console.log(this.QQurl);
      // 使用$nextTick确保数据渲染
      this.$nextTick(() => {
        this.QQcrateQrcode();
      });
    },
    weibo() {
      let url = encodeURIComponent(this.getUrl());
      let srcUrl = "";
      this.every.cover
        ? (srcUrl = `pic=${this.$global.imgUrl + this.every.cover}&`)
        : (srcUrl = "");
      window.open(
        `https://service.weibo.com/share/share.php?${srcUrl}url=${url}&title=${this.every.title}`
      );
    },
    space() {
      let url = encodeURIComponent(this.getUrl());
      let srcUrl = "";
      this.every.cover
        ? (srcUrl = `pics=${this.$global.imgUrl + this.every.cover}&`)
        : (srcUrl = "");
      window.open(
        `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?${srcUrl}url=${url}&title=${this.every.title}`
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.item-container {
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  margin-bottom: 14px;
  padding: 25px 40px;
  width: 100%;
  border: 1px solid #A3CBE7;
  border-radius: 10px;
  .title {
    font-size: 18px;
    vertical-align: middle;
    color: #263d78;
    cursor: pointer;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    .column {
      color: #0491ae;
    }
    &::v-deep p {
      display: inline-block !important;
    }
  }

  .anther {
    margin: 9px 0;
    font-size: 12px;
    color: #666666;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    li {
      display: inline;
      margin-right: 10px;
    }
  }
  .icon {
    display: flex;
    margin-top: 20px;
    height: 37px;
    background: #ffffff;
    li {
      border: 1px solid #dfe8f2;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      padding: 10px;
      box-sizing: border-box;
      cursor: pointer;
      &:not(:last-child) {
        border-right: none;
      }
      img {
        width: 20px;
        height: 20px;
        margin-right: 6px;
      }
    }
    .readBtn {
      border: 1px solid #dfe8f2;
      border-radius: 0;
      height: 100%;
      img {
        width: 20px;
        height: 20px;
        margin-right: 6px;
        vertical-align: middle;
      }
      &:focus {
        box-shadow: none !important;
      }
    }
    .share:hover {
      .share_box {
        display: block;
      }
    }
    .share {
      position: relative;
      .share_box {
        cursor: pointer;
        display: none;
        right: -133px;
        top: -130px;
        position: absolute;
        width: 133px;
        height: 167px;
        background: #ffffff;
        box-shadow: 3px 1px 7px 0px rgba(8, 8, 64, 0.23);
        border-radius: 10px;
        .weChat:hover {
          .ma {
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 99;
          }
        }

        .weChat {
          position: relative;
          .ma {
            display: none;
            left: 123px !important;
            position: absolute !important;
            width: 200px !important;
            top: -10px !important;
            height: 167px !important;
            background: white !important;
            box-shadow: 3px 1px 7px 0px rgba(8, 8, 64, 0.23);
            border-radius: 10px;
          }
        }
        .qq:hover {
          .ma {
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
        .qq {
          position: relative;
          .ma {
            display: none;
            left: 123px !important;
            position: absolute !important;
            width: 200px !important;
            top: -90px !important;
            height: 167px !important;
            background: white !important;
            box-shadow: 3px 1px 7px 0px rgba(8, 8, 64, 0.23);
            border-radius: 10px;
          }
        }
        li {
          border: none;
          margin-top: 10px;
          margin-bottom: 0px;
          //display: flex;
          flex-wrap: nowrap;
          //background: pink;
          justify-content: center;
          align-items: center;
          width: 133px;
          height: 30px;

          div {
            width: 60px;
            //background: yellow;
            margin-left: 10px;
          }
          img {
            width: 20px;
            height: 20px;
          }
        }
        .sanjiao {
          width: 0;
          height: 0;
          border-top: 3px solid transparent;
          border-right: 6px solid #fff;
          position: absolute;
          top: 50%;
          margin-top: -3px;
          left: -6px;
          border-bottom: 3px solid transparent;

          //background: pink;
        }
      }
    }
  }
  .time {
    position: absolute;
    bottom: 5px;
    right: 0;
  }
  .content {
    width: 100%;
    // height: 60px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
  .item-img {
    display: flex;
    width: 100%;
    height: 100%;
    .right {
      width: 150px;
      height: 150px;
      margin-right: 15px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .left {
      position: relative;
      flex: 1;
      padding-bottom: 45px;
    }
  }
  .item-no-img {
    position: relative;
    width: 100%;
    height: 100%;
    // padding-bottom: 45px;
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}
</style>
